import { render } from "./cardsselectcolumn.vue?vue&type=template&id=2e6221c6&scoped=true"
import script from "./cardsselectcolumn.vue?vue&type=script&lang=js"
export * from "./cardsselectcolumn.vue?vue&type=script&lang=js"

import "./cardsselectcolumn.vue?vue&type=style&index=0&id=2e6221c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6221c6"]])

export default __exports__